<template>
	<div class="pagination-wrap">
		<el-pagination
		background
		layout="prev, pager, next"
		:page-size= this.pageSize
		:total=this.total
		@current-change="handleCurrentChange"
		:current-page="this.pageNum"
		hide-on-single-page
		></el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'pagination',
		props: {
			pageSize: {
				type: Number
			},
			pageNum: {
				type: Number
			},
			total: {
				type: Number
			}
		},
		data() {
			return {

			}
		},
		methods: {
			handleCurrentChange(e){
				this.$emit('pageChange', {
					number: e
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pagination-wrap{
		display: flex;
		justify-content: center;
		margin: 30px 0 0;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: var(--color-text-a);
		color: #fff;
	}
	/deep/ .el-pagination.is-background .el-pager li:hover{
		color: var(--color-text-a)
	}
</style>
